import PageContainer from '../components/PageContainer'
import MetaDesc from '../components/MetaDesc'

const Faq = () => {
  return (
    <PageContainer>
      <MetaDesc>
        Frequently asked questions about Mastermine coming to Steam
      </MetaDesc>

      <h2>Mastermine is coming to Steam!</h2>

      <h3>What if I purchased on itch.io?</h3>

      <p>
        If you bought a copy of Mastermine on itch.io don't worry, you'll be
        emailed a Steam key at a time close to the game's release date. You will
        <b> not</b> be required to purchase the game again.
      </p>

      <p>
        All your progress will also be moved across automatically after downloading
        the game via Steam.
      </p>

      <h3>Why Steam?</h3>

      <p>
        Moving to Steam, the biggest platform for PC games comes with a bunch of
        awesome benefits, with just a few being:
      </p>

      <ul>
        <li>Steam Achievements for all in-game challenges that you can show off on your profile</li>
        <li>Steam Cloud syncs your save file between your machines</li>
        <li>Steam Stats allow you to track statistics like Cubes Solved and compare them against the world</li>
        <li>Support for SteamOS machines, Steam in-home streaming & Steam Link</li>
        <li>Steam Rich Presence shows your friends what you're solving</li>
      </ul>

      <h3>How does save syncing work?</h3>

      <p>
        Via Steam, your save file including your store credits, store-bought
        powerups & skins, etc. will be automatically kept up to date between all
        of the PCs you play Mastermine on. Save syncing works across all operating
        systems (Windows, macOS & Linux).
      </p>

      <p>
        Save syncing <em>doesn't</em> affect save files on your phone (iOS/Android)
        at the moment, as it is a feature of Steam.
      </p>

      <p>
        If you previously bought the game on itch.io, the Steam version will pick
        up and continue to use your previous save file. Just make sure to install
        the Steam version on the PC you played your itch.io copy on.
      </p>

      <h3>Will you support itch.io moving forward?</h3>

      <p>
        When the Steam version of Mastermine is released, the itch.io store page
        will be wound down and all future updates for the game will release on Steam.
      </p>

      <p>
        Maintaining one PC version of the game means higher quality updates for
        everyone.
      </p>

      <h3>Which update/game version is releasing on Steam?</h3>

      <p>
        On Steam release day, the game will be update 1.11.2 - this is the same
        version as is currently available on itch.io, plus changes relating
        to supporting Steam features like Achievements. More major updates will
        be coming <em>after</em> everyone has moved over to Steam.
      </p>
    </PageContainer>
  )
}

export default Faq
